/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Carousel from 'react-material-ui-carousel'
import {
  mdiClipboardTextClock,
  mdiMagnifyExpand,
  mdiPanoramaVariant,
} from '@mdi/js'
import Icon from '@mdi/react'

import { getItemByBarcode } from '../AttendanceActions'
import { dateFormatedFullDate } from '../../../util/utils'
import BaseRelatoryPage from '../../../components/hooks/BaseRelatoryPage'
import BaseFilter from '../../../components/hooks/BaseFilter'
import BaseCreatePage from '../../../components/hooks/BaseCreatePage'
import Tabs from '../../../components/hooks/BaseTabs/Tabs'
import Tab from '../../../components/hooks/BaseTabs/Tab'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'

const useStyles = makeStyles({
  centerImage: {
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
    height: 'auto',
    maxWidth: '100%',
    cursor: 'pointer',
  },
})

function ItemHistoryByBarcode() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { itemStatus, documents } = useSelector(
    state => state.attendance.itemByBarcode
  )

  const [barcode, setBarcode] = useState('')
  const [tabValue, setTabValue] = useState(0)
  const [searched, setSearched] = useState(false)

  const modalRef = useRef()
  const modalImgRef = useRef()
  const captionTextRef = useRef()

  const clickImg = e => {
    modalRef.current.style.display = 'block'
    modalImgRef.current.src = e.target.src
    captionTextRef.current.innerHTML = e.target.alt
  }

  const closesModal = () => {
    modalRef.current.style.display = 'none'
  }

  const handleSearch = e => {
    e.preventDefault()
    if (!barcode.trim()) return
    dispatch(getItemByBarcode(barcode.trim()))
    setSearched(true)
  }

  return (
    <BaseRelatoryPage title="Fotos dos Itens">
      <Grid container spacing={2} style={{ marginTop: '1em' }}>
        <Grid item xs={12}>
          <BaseFilter>
            <Grid item xs={12} sm={6}>
              <form onSubmit={handleSearch}>
                <TextField
                  label="Código de barras"
                  value={barcode}
                  onChange={e => setBarcode(e.target.value)}
                  fullWidth
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton type="submit">
                          <Icon path={mdiMagnifyExpand} size={1} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </form>
            </Grid>
          </BaseFilter>
        </Grid>

        {searched && (
          <>
            <Grid item xs={12}>
              <Tabs>
                <Tab
                  tabIndex={0}
                  value={tabValue}
                  setValue={setTabValue}
                  icon={mdiClipboardTextClock}
                  label="Histórico"
                  removeNavigation={false}
                />
                <Tab
                  tabIndex={1}
                  value={tabValue}
                  setValue={setTabValue}
                  icon={mdiPanoramaVariant}
                  label="Fotos"
                  removeNavigation={false}
                />
              </Tabs>
            </Grid>

            <Grid item xs={12}>
              {tabValue === 0 && (
                <Table aria-label="item history table">
                  <TableHead>
                    <TableRow>
                      <StyledTableCellHeader>Usuário</StyledTableCellHeader>
                      <StyledTableCellHeader>Status</StyledTableCellHeader>
                      <StyledTableCellHeader>Data</StyledTableCellHeader>
                      <StyledTableCellHeader>
                        O que foi alterado / Observação
                      </StyledTableCellHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itemStatus?.map(item => (
                      <TableRow key={item.id} hover>
                        <StyledTableCellBody>
                          {item.user.name}
                        </StyledTableCellBody>
                        <StyledTableCellBody>
                          {item.status.name}
                        </StyledTableCellBody>
                        <StyledTableCellBody>
                          {dateFormatedFullDate(item.created_at)}
                        </StyledTableCellBody>
                        <StyledTableCellBody>
                          {item.whatChanged}
                        </StyledTableCellBody>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}

              {tabValue === 1 && documents?.length > 0 && (
                <Carousel autoPlay={false} navButtonsAlwaysVisible>
                  {documents?.map((item, key) => (
                    <Box
                      key={key}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '12px',
                      }}
                    >
                      {item?.context && (
                        <BaseCreatePage
                          page="Contexto da foto"
                          path={item?.context}
                          hiddenReturn
                        />
                      )}
                      <img
                        src={item.link}
                        alt={`Foto ${key + 1}`}
                        className={classes.centerImage}
                        onClick={clickImg}
                      />
                    </Box>
                  ))}
                </Carousel>
              )}
            </Grid>
          </>
        )}

        <div id="myModal" ref={modalRef} className="modal">
          <span className="close" onClick={closesModal}>
            &times;
          </span>
          <img className="modal-content" ref={modalImgRef} id="img01" alt="" />
          <div id="caption" ref={captionTextRef} />
        </div>
      </Grid>
    </BaseRelatoryPage>
  )
}

export default React.memo(ItemHistoryByBarcode)
